//Script for dropdown menu 
class NavMenu {

    constructor(menu, button, wrapper) {
        this.menu = menu;
        this.button = button;
        this.wrapper = wrapper;
        this.firstFocusable = this.getFirstFocusable();
        this.lastFocusable = this.getLastFocusable();
        this.button.addEventListener("click", this.toggleMenu.bind(this));
        this.menuIsOpen = false;
        this.transitionEndIsAdded = false;
        this.prefersReduced =  window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||window.matchMedia("(prefers-reduced-motion: reduce)").matches ==true;
    }

    toggleMenu(e) {
        e.preventDefault();
        if (this.menuIsOpen) {
            this.closeMenu();
        } else {
            this.openMenu(e);
        }
    }

    openMenu(e){
        this.menuIsOpen = true;
        this.menu.style.visibility = "visible";
        this.wrapper.classList.add("open");
        this.button.classList.add("active");
        this.button.setAttribute("aria-expanded", "true");
        this.firstFocusable.focus();
        this.menu.addEventListener("focusout", this.focusHandler.bind(this));
        this.menu.addEventListener("keydown", this.escHandler.bind(this));
        document.addEventListener('click', this.closeMenuOnClick.bind(this)); 
    }

    closeMenu(){
        this.menuIsOpen = false;
        this.wrapper.classList.remove("open");
        this.button.classList.remove("active");
        this.button.setAttribute("aria-expanded", "false");
        this.button.focus();
        this.menu.removeEventListener("focusout", this.focusHandler.bind(this));
        this.menu.removeEventListener("keydown", this.escHandler.bind(this));
        document.removeEventListener('click', this.closeMenuOnClick.bind(this));
        if(this.prefersReduced){
            this.hideVisibilityOnEnd();
            return;
        };
        if(!this.transitionEndIsAdded){
            this.menu.addEventListener("transitionend", ()=>this.hideVisibilityOnEnd());
        }

    }
    
    hideVisibilityOnEnd(){
        if(this.menuIsOpen) return;
        this.menu.style.visibility = "hidden";
    }

    closeMenuClean(){
        this.menu.classList.remove("toggled");
        this.button.classList.remove("is-active");
        this.button.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("scroll-lock");
        if(this.prefersReduced){
            this.hideVisibilityOnEnd();
            return;
        };
    }

    closeMenuOnClick(e){
        if(e.target == this.button) return;
        console.log(e.target,this.menuIsOpen, this.menu.contains(e.target));
        if (!this.menu.contains(e.target) && this.menuIsOpen) {
            this.closeMenu();
        }
    }; 

    getFocusable(){
        if(!this.focusable){
            this.focusable = [];
            const allDescendants = this.menu.querySelectorAll("*");
            allDescendants.forEach((child) => {
                if (this.isFocusable(child)) {
                    this.focusable.push(child);
                }
            });
        }
        return this.focusable;
    }

    getFirstFocusable() {
        let focusable = this.getFocusable();
        return focusable[0];
    }

    getLastFocusable() {
        let focusable = this.getFocusable();
        return focusable[focusable.length - 1];
    }

    isFocusable(element) {
        if (element.tabIndex < 0) {
            return false;
        }

        if (element.disabled) {
            return false;
        }
        if(!element.offsetParent){
            return false;
        }
        switch (element.nodeName) {
            case "A":
                return !!element.href && element.rel != "ignore";
            case "INPUT":
                return element.type != "hidden";
            case "BUTTON":
            case "SELECT":
            case "TEXTAREA":
                return true;
            default:
                return false;
        }
    }

    focusHandler(e) {
        if(e.relatedTarget == this.button){
            this.closeMenu();
            return;
        }
        if(e.target == this.lastFocusable && !this.menu.contains(e.relatedTarget)){
            this.closeMenu();
            return;
        }
    }

    escHandler(e){
        if(e.key == "Escape"){
            this.closeMenu();
        }
    }

}


const subMenuLi = document.querySelectorAll("#menu-main-menu>.menu-item-has-children");
if(subMenuLi.length){
    subMenuLi.forEach((li)=>{
        const id = li.id;
        const anchor = li.querySelector("a");
        anchor.setAttribute("aria-expanded", "false");
        anchor.setAttribute("role", "button");
        anchor.setAttribute("aria-controls", `submenu-${id}`);
        const submenu = anchor.nextElementSibling;
        submenu.style.visibility = "hidden";
        submenu.id = `submenu-${id}`
        const nav = new NavMenu(submenu, anchor, li);
    });
}
